// Puente de SOLO LECTURA hacia `infrastructure`/datacenters y `clients` (plan.md §3.4, decisión
// M de tasks.md). Encauza por infrastructure/ el acceso hoy vía `datacenters.api.js` (DCs
// Kyndryl) y `clientDatacenters.api.js` (DCs propios del cliente) legado. Retiro:
// getKyndrylDatacenters ⇒ cuando migre `infrastructure`/datacenters; getClientDatacenters ⇒
// cuando migre `clients` (ver ROADMAP.md).

import { z } from 'zod';
import apiClient from '@shared/api/http';
import type { Id } from '../domain/enterprise.types';
import type { DatacenterOption } from '../domain/options.types';

const IdSchema = z.union([z.string(), z.number()]).transform(String);

// v1 responde camelCase; el dominio de este contexto conserva `country_name`.
const DatacenterOptionDtoSchema = z
  .object({
    id: IdSchema,
    name: z.string(),
    city: z.string().nullish(),
    countryName: z.string().nullish(),
  })
  .transform(({ countryName, ...rest }) => ({ ...rest, country_name: countryName }));

// `/datacenters` responde paginado (`{ items, ... }`); las colecciones anidadas bajo `/clients`
// responden array plano. Este preprocess acepta ambas formas sin duplicar el parser.
const DatacenterOptionListSchema = z.preprocess(
  (value) =>
    Array.isArray(value)
      ? value
      : ((value as { items?: unknown } | null)?.items ?? []),
  z.array(DatacenterOptionDtoSchema)
);

export const datacenterOptionsRepository = {
  async getKyndrylDatacenters(): Promise<DatacenterOption[]> {
    const { data } = await apiClient.get('/datacenters');
    return DatacenterOptionListSchema.parse(data);
  },

  // v1 renombró `client-datacenters` a `owned-datacenters` (mapping.md, recursos del cliente).
  async getClientDatacenters(clientId: Id): Promise<DatacenterOption[]> {
    const { data } = await apiClient.get(`/clients/${clientId}/owned-datacenters`);
    return DatacenterOptionListSchema.parse(data);
  },
};
